export default __webpack_public_path__ + "assets/medium.43449d8ab69a2872a9f9149e30bd7f89.mp3";